import moment from "moment-timezone";

export const extractIanaTimezones = (items = []) => {
    const timezones = [];

    items.forEach((item) => {
        const timezone = {
            title: item?.title,
            id: item?.id,
        };

        item?.standardCodes?.forEach((subItem) => {
            if (subItem?.itemCodeStandardName === "iana") {
                timezone.standardCodeValue = subItem?.standardCodeValue;
                timezones.push(timezone);
            }
        });
    });

    return timezones;
};

export const updateSelectedTimeZone = (timeZone, selectedDateTime) => {
    const localTime = moment(selectedDateTime);
    const selectedTimeZoneFormat = moment().tz(timeZone);
    selectedTimeZoneFormat.set(localTime?.toObject());
    return selectedTimeZoneFormat;
};

export const isFutureTime = (timeZone, selectedDateTime) => {
    const currentTime = moment().tz(timeZone).format();
    const selectedTimeZone = updateSelectedTimeZone(timeZone, selectedDateTime);
    return Date.parse(currentTime) > Date.parse(selectedTimeZone);
};
